import React from 'react'
import VesselRow from './VesselRow'
import { useLocation } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearVessels, getVesssels, searchVessels } from '../../features/Vessels/VesselSlice'
import Search from '../../components/Search'
import { DatePicker } from 'antd'
import { selectVessel } from '../../features/Vessels/VesselSlice'
import SkeltonTable from '../../components/SkeltonTable'
import format from 'date-fns/format'
import Papa from 'papaparse';
import { fetchCSVDocumentforVessels } from '../../features/EUA/EuaSlice'
import Clipboard from "../../assets/icons/voyages/clipboard-import.svg"
const { RangePicker } = DatePicker

const Vessel = () => {

  const dispatch = useDispatch()
  const location = useLocation();
  const { status, vessels, page } = useSelector((state) => state.vessel)
  const { selectedVessel } = useSelector((state) => state.vessel)
  const [updatedPage, setUpdatedPage] = useState(page)
  const scrollableArea = useRef(null)
  const { csvDocument } = useSelector((state) => state.eua)
  const [customDate, setCutomDate] = useState(null)
  const [IMO, setIMO] = useState(selectedVessel?.imo_number)
  const [isSearching, setIsSearching] = useState(false);
  // useEffect(() => {
  //   dispatch(getVesssels(1))
  // }, []);

  console.log(selectedVessel)

  const DateChangeHandler = (date) => {
    setCutomDate(date)
    if (date !== null) {
      const temp = {
        start_date: format(new Date(date[0]), "yyyy-MM-dd"),
        end_date: format(new Date(date[1]), "yyyy-MM-dd"),
        imo_number: selectedVessel.imo_number
      }
      dispatch(fetchCSVDocumentforVessels(temp))
    }
  }

  const downloadCsv = () => {
    const rearrangedData = [];
    let prevVesselName = '';

    csvDocument.forEach((row) => {
      const { vessel_name, ...rest } = row;

      if (!vessel_name || vessel_name === prevVesselName) {
        rearrangedData.push({ vessel_name: '', ...rest });
      } else {
        rearrangedData.push({ vessel_name, ...rest });
        prevVesselName = vessel_name;
      }

    });

    const result = rearrangedData.map((originalData, key) => {
      return {
        "IMO Number": originalData.imo_number,
        "Vessel Name": originalData.vessel_name,
        "Owner": originalData.active_owner,
        "Casper ID": originalData.casper_id,
        "Start Date": originalData.min_as_of_date_voyage_data,
        "End Date": originalData.max_as_of_date_voyage_data,
        "Start Port": originalData.start_port,
        "End Port": originalData.end_port,
        "EU Identifier": originalData.eu_identifier,
        "AER": originalData?.cii?.toFixed(3),
        "CII": originalData.technical_grade,
        "WTW (MT)": originalData?.wtw?.toFixed(3),
        "TTW (MT)": originalData?.ttw?.toFixed(3),
        "GHG Intensity (gCO2/MJ)": originalData?.total_ghg?.toFixed(3),
        "Compliance Balance (gCO2eq)": originalData?.compliance_balance?.toFixed(3),
        "FEUM Penalty (Euros)": originalData?.penalty?.toFixed(3),

        // "CO2 Eq ETS": originalData?.co2eq_emissions_ets?.toFixed(3),
        // "EUA Due": originalData?.eua_due?.toFixed(3),
      }
    })
    const csv = Papa.unparse(result);
    const blob = new Blob([csv], { type: 'text/csv' });

    const link = document.createElement('a');

    link.href = URL.createObjectURL(blob);
    link.download = 'data.csv';
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  };



  const getVessselsData = () => {
    if (status !== 'loading' && !isSearching) {
      dispatch(getVesssels(page)).then((result) => {
        if (page === 1 && result.payload) {
          const payload = {
            imo_number: result.payload[0].imo_number,
            casper_id: result.payload[0].casper_id
          }
          dispatch(selectVessel(payload))
        }
      })
    }
  }

  useEffect(() => {
    if (vessels.length === 0 && !isSearching) {
      getVessselsData()
    }
  }, [updatedPage])

  const onChange = (date, dateString) => {
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      scrollableArea.current;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setUpdatedPage(updatedPage + 1)
      getVessselsData()
    }
  }
  const handleRowSelection = (voyage, number) => {

    setIMO(number)
    setCutomDate(null)
    const payload = {
      imo_number: number,
      casper_id: voyage.casper_id
    }
    dispatch(selectVessel(payload));
  };

  const searchHandler = (record, setOpen, setValue) => {
    setValue(record.vessel_name)
    setIsSearching(true);
    const params = {
      vessel_name: record.vessel_name,
      casper_id: record.casper_id,
      imo_number: record.imo_number,
      page: 1
    }
    handleRowSelection(record, record.imo_number)
    setOpen(false)
    dispatch(clearVessels())
    dispatch(searchVessels(params))
  }

  const clearSearchHandler = (setValue) => {
    setValue(null)
    setIsSearching(false);
    dispatch(clearVessels())
    dispatch(getVesssels(1))
  }

  useEffect(() => {
    // Clear search when user navigates to another page
    // setValue(null)
    dispatch(clearVessels())
    setUpdatedPage(1)
  }, [location.pathname]);

  return (
    <div className="card">
      <div className="vessel-card-filter">
        <div style={{ width: "50%" }}>
          <Search onClear={clearSearchHandler} onSelect={searchHandler} />
        </div>

        <div className='vessel-card-report-download'>
          {/* <DatePicker size='large' onChange={onChange} /> */}
          <RangePicker getPopupContainer={(trigger) => trigger.parentNode} format="YYYY-MM-DD" value={customDate} style={{ width: 250 }} onChange={DateChangeHandler} />
          {csvDocument !== null && customDate !== null ?
            <div onClick={downloadCsv} style={{ display: "flex", flexDirection: "column" }}>
              <img src={Clipboard} style={{ height: "25px", cursor: "pointer" }} alt="" />
              {/* <span className='card-icon-span'>{"Download Report"}</span> */}
            </div> : ""
          }
        </div>
      </div>
      <div onScroll={handleScroll} ref={scrollableArea} className="vessel-card-table"
      // style={{ height: "60vh" }}
      >
       {!Array.isArray(vessels) || vessels.length === 0 ?
  <SkeltonTable />
  :
  vessels.map((voyage, index) => {
            return (
              <VesselRow key={index} voyage={voyage} name={voyage.vessel_name} number={voyage.casper_id} onSelect={() => handleRowSelection(voyage, voyage.imo_number)} />
            )
          })
        }
       
      </div>
    </div>
  )
}

export default Vessel
